<template>
  <div>
    <b-card border-variant="danger" v-if="errore_caricamento">
      <b-row class="match-height">
        <b-col
          md="8"
        >
          <div v-if="this.errore_messaggio == ''">
            <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
            <p>Ti preghiamo di segnalare il problema all'assistenza tecnica, grazie</p>
          </div>
          <div v-else>
            <h4 class="mt-0 mb-0 text-danger">{{ this.errore_messaggio }}</h4>
          </div>
        </b-col>
        <b-col 
          md="4"
          class="text-center"
        >
          <b-button
          variant="primary"
          :to="{ name: 'area-clienti-dashboard' }"
          >
              <feather-icon
                  icon="CornerUpLeftIcon"
                  size="16"
                  class="mr-1"
              />Torna alla Dashboard
          </b-button>
        </b-col>
      </b-row>
        
    </b-card>
    
    <div class="text-center my-3" v-if="Caricato == false">
        <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem;"
            class="mr-1"
            label="loading"
        />
    </div>

    <div v-else>
        <h2 class="mb-2">Licenza n. {{ this.dati.licenseData.ref_code }}</h2>

        <p class="mb-2">Spett.le {{ this.campiform.dati_cliente.billing.company_name }}, La sua licenza ci risulta in disputa, La invitiamo ad inserire un nuovo metodo di pagamento.</p>

        <div v-if="stato_licenza == 'omaggio_auto_attivato'">
            <h3>Licenza attiva</h3>
            messaggio da definire + link alla visualizzazione della licenza (dovremo cambiare la rotta di questo wizzard)
        </div>
        <div v-else>            
          <b-row class="justify-content-md-center">
            <b-col md="10" lg="6">
              <changepayment 
                field_stripe_api_key = "pk_test_519861GIHR2Kx1sUUGS1syJpea3Noe1NP8ypNCsKkMFOTFjjkwnZyWKvLKdg3KEY8OcQfK6dwtXkKgXFtrmRwXcIV00QZ5HNGox"
                :field_payment_intent = this.dati.licenseData.payment_intent_secret_stripe
                :field_license_id = this.id_licenza
                :field_customer = this.dati.licenseData.user.stripe_id
                :field_codice_contratto = this.dati.licenseData.ref_code 
                :field_product_id = this.dati.licenseData.product_id_stripe
                :field_is_subscription = this.isSubscription
                :field_vat_scheme_id = this.campiform.dati_cliente.billing.vat_scheme_id
                :field_split_payment = this.campiform.dati_cliente.billing.split_payment
              />

            </b-col>
          </b-row>

        </div>
            



    </div>

      
  </div>
</template>

<script>
import router from '@/router'
import { BTabs, BTab, BRow, BCol, BCard, BCardTitle, BCardHeader, BCardBody, BCardText, BSpinner, BButton, BSidebar, VBToggle, BBadge, BForm, BFormGroup, BFormCheckbox, BFormInput, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import showdata from '@core/components/showdata/showdata.vue'
import { ValidationProvider, ValidationObserver, localize, configure  } from 'vee-validate'
import it from 'vee-validate/dist/locale/it.json'
import {
  required, length,
} from '@validations'
import moment from 'moment'
import changepayment from '@/@core/components/paymentform/changepayment_v1.vue'

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard, 
    BCardTitle, 
    BCardHeader, 
    BCardBody, 
    BCardText, 
    BSpinner, 
    BButton,
    BSidebar, 
    VBToggle, 
    BBadge,
    BForm, 
    BFormGroup, 
    BFormCheckbox, 
    BFormInput, 
    VBTooltip, 

    showdata,
    changepayment,

    ValidationProvider,
    ValidationObserver,

    ValidationProvider,
    ValidationObserver,
    it,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      Caricato: false,
      errore_caricamento: false,
      
      id_licenza: '',
      id_dispusta: '',
      check_disputa: [], 
      dati: [], 
      campiform: [], 
      stato_licenza: 'da_accettare',
      errore_messaggio: '',

      Caricato_testi_contratto: false,
      errore_testi_contratto: false,

      isSubscription: false,
      
      required,
      length,
      
      action_press_otp: false,
      action_press: false,
      action_press_donwload_plico: false,

      btn_verifica: true,
      btn_scaricare: false,
      link_download_pdf: '',
    }
  },
  created() {
    console.log("id licenza passato su DISPUTA -> "+router.currentRoute.params.id_riga);
    console.log("id disputa passata su DISPUTA -> "+router.currentRoute.params.id_disputa);

    this.id_licenza = parseInt(router.currentRoute.params.id_riga, 10);
    this.id_dispusta = parseInt(router.currentRoute.params.id_disputa, 10);

    this.$http.get('api/customer/license/check_disputa/'+this.id_licenza).then(response => {
        if(response.status===200){
          //ok dati ricevuti
          // check autorizzazione ad accedere ai dati oppure no
          if(response.data.statusCode===200){
            //ok autorizzato ! => proseguo
            this.check_disputa = response.data.reply

            console.log("FINE estrazioni dati licenza --------------------")
            console.log(this.check_disputa)

            if((this.check_disputa.disputa !== null) && (this.check_disputa.bonifico_normale === null)){
              //c'è una dispusta senza il pagamento tramite bonifico normale => ok, visualizza questa pagina
              //estraggo i dati della licenza

              this.$http.get('api/customer/license/card/'+this.id_licenza).then(response => { 
                /*  
                console.log(response)
                console.log("stato esterno -> "+response.status)
                console.log("stato interno -> "+response.data.statusCode)
                */

                if(response.status===200){
                  //ok dati ricevuti
                  // check autorizzazione ad accedere ai dati oppure no
                  if(response.data.statusCode===200){
                    //ok autorizzato ! => proseguo
                    this.dati = response.data.reply

                    console.log("FINE estrazioni dati licenza --------------------")
                    console.log(this.dati)

                    //FONDAMENTALE PER STRIPE !!
                    if(this.dati.licenseData.type == 'Abbonamento'){
                      this.isSubscription = true;
                    } else {
                      this.isSubscription = false; //OneShot
                    }

                    //FONDAMENTALE PER LA GESTIONE CORRETTA DI STRIPE ELEMENTS
                    if(this.dati.licenseData.payment_intent_secret_stripe == null){
                      //se è null lo trosformiamo in stringa vuota altrimenti fa casino
                      this.dati.licenseData.payment_intent_secret_stripe = ''
                    }            


                    this.estrazioneDatiBilling(this.dati.licenseData.user.id)

                    /* forzo il passaggio al terzo step => PAGAMENTO */
                    console.log("start CAMBIO DATI PER IL PAGAMENTO - Speriamo Bene ...")

                    if(this.dati.licenseData.price == 0){
                      //licenza omaggio
                      this.stato_licenza = 'omaggio_auto_attivato'
                    } else {
                      this.stato_licenza = 'accettato'
                    }  
                    
                  } else {
                    if(response.data.statusCode===403){
                      //accesso ad una licenza che non è del cliente loggato, furbetto beccato!
                      this.errore_messaggio = "Operazione non autorizzata! stai cercando di accedere ad una licenza non di tua pertinenza."
                    }
                    
                    this.Caricato = false;
                    this.errore_caricamento = true;
                  }
                } else {
                  console.log("qui ------------------")
                  if(response.status===401){
                    //accesso "Unauthenticated" -> accade quando si sviene sloggati dall'api
                    console.error("Errore api -> "+response.data.reply['message'])

                    if(logoutGeneral() === true){
                      // Redirect to login page
                      //this.$router.push({ name: 'auth-login' })
                      this.$router.replace('/login?status=again')
                    }
                  }

                  this.Caricato = false;
                  this.errore_caricamento = true;
                }
              
              }).catch(e => {
                /*
                this.Caricato = false;
                this.errore_caricamento = true;
                */

                console.log("Errore api ......")
                console.log(e)

                this.Caricato = false;
                this.errore_caricamento = true;

              });


            } else {
              //nel caso che la licenza non sia in dispusta
              // o nel caso in cui la licenza sia in dispusta ma pagata con bonifico normale
              // redirect verso pagina "show" normale della licenza
              this.$router.replace('/area-clienti/licenze/show/'+this.id_licenza)
            }
            
          } else {
            if(response.data.statusCode===403){
              //accesso ad una licenza che non è del cliente loggato, furbetto beccato!
              this.errore_messaggio = "Operazione non autorizzata! stai cercando di accedere ad una licenza non di tua pertinenza."
            }
            
            this.Caricato = false;
            this.errore_caricamento = true;
          }
        } else {
          console.log("qui ------------------")
          if(response.status===401){
            //accesso "Unauthenticated" -> accade quando si sviene sloggati dall'api
            console.error("Errore api -> "+response.data.reply['message'])

            //Redirect sulla scrivaia
            this.$router.push({ name: 'area-clienti-dashboard' })
          }

          this.Caricato = false;
          this.errore_caricamento = true;
        }
      
      }).catch(e => {
        /*
        this.Caricato = false;
        this.errore_caricamento = true;
        */

        console.log("Errore api ......")
        console.log(e)

        this.Caricato = false;
        this.errore_caricamento = true;

      });
    

    //errori validazione in italiano
    localize({
      it: {
        messages: it.messages,
      },
    })
    // Imposta la lingua predefinita
    localize('it');
  },
  methods: { 
    estrazioneDatiBilling(id_user){

      const countryPromise = this.$http.get('api/fs/country/list')
      const provincePromise = this.$http.get('api/fs/province/list')
      const infoBillingPromise = this.$http.get('/api/customer/user/customerbillingcard/'+id_user)

      Promise.all([countryPromise, provincePromise, infoBillingPromise]).then(response => {
        if((response[0].data.statusCode===200) && (response[1].data.statusCode===200) && (response[2].data.statusCode===200)){
          
          console.log(response[0])
          console.log(response[1])
          console.log(response[2])
          

          this.campiform.dati_cliente = response[2].data.reply

          //nazione
          var id_nazione = this.campiform.dati_cliente.billing.country_id
          var nazione = response[0].data.reply.filter(function(elem){
              if(elem.value == id_nazione){
              return elem.text
              }
          })
          this.campiform.dati_cliente.billing.country_name = nazione[0].text

          //provincia
          var id_provincia = this.campiform.dati_cliente.billing.province_id
          var provincia = response[1].data.reply.filter(function(elem){
              if(elem.value == id_provincia){
                return elem.text
              }
          })
          this.campiform.dati_cliente.billing.province_name = provincia[0].text

          //fine loader
          this.Caricato = true;
          
        } else {
          console.log("Errore api ...... estrazioneDatiBilling()")
        }        
      })
    },
    
    /*
    PagaContratto(){
      this.Caricato = false;

      this.$http.post('/api/customer/stripe/checkout/'+this.id_licenza).then(response => { 
        console.log(response)
        console.log("redirect ->\n\n"+response.data.reply.checkout_url)

        // OLD VERSION
        // redirect verso stripe
        window.location.href = response.data.reply.checkout_url;
        
        //NON RIMUOVO MAI IL LOADER COSì NON VEDO LO SFARFALLIO DELLA PAGINA ;-)
        //this.Caricato = true;
      
      }).catch(e => {
        this.Caricato = true;
        console.log(e);
      }); 

    },
    */

    formattazioneOrario(value, stringa){
      return moment(String(value)).locale('it').format(stringa)
    },
    
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';

.wizard-header{
  display: none;
}

/* disabilità il ckick sui titoli del wizzard */
.vue-form-wizard .wizard-nav-pills a, .vue-form-wizard .wizard-nav-pills li{
  cursor: not-allowed;
  pointer-events: none;
}

.box_testi_contratto{
  width: 100%;
  max-height: 90px;
  overflow-y: visible;
  overflow-x: hidden;
  background-color: rgba(34, 41, 47, 0.03);
  border: 1px solid rgba(34, 41, 47, 0.08);
  padding: 6px 10px;
  font-size: 11px;
}
.box_testi_contratto p{
  line-height: 13px;
  padding-bottom: 0px;
  margin-bottom: 9px;
}

.vue-form-wizard .wizard-navigation .wizard-nav li .wizard-icon-circle .wizard-icon-container {
  background-color: #14BEAE !important;
}
.vue-form-wizard .wizard-navigation .wizard-nav li a .active {
  color: #14BEAE !important;
}
</style>
